require('./hireCardPremiumPackSuccess.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getSplittedNumber } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
const HireSuccessStepCardImage = require('components/cards/hireSuccessStepCardImage/hireSuccessStepCardImage');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @constants
const { PENDING } = require('constants/hireCardSubmitScenarios');
const {
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_VARIABLE,
    EURO_SYMBOL,
    EURO_TEXT,
    PERCENTAGE_SYMBOL,
    PREMIUM_PACK_HIRING
} = require('constants/index');
const { catalogue, analyticsId } = require('../analytics/hireCardPremiumPackAnalytics');

class HireCardPremiumPackSuccess extends React.Component {

    buildSummary() {
        const {
            immAccount,
            immHireCardNameSelector,
            immHireCreditLimit,
            immHirePaymentMethod,
        } = this.props;

        const limitObj = {
            amount: immHireCreditLimit.get('creditLimit'),
            currency: EURO_TEXT
        };

        const paymentMethod = {
            [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('hireCardPremiumPack-summaryMethodOfPaymentFullPay')}`,
            [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardPremiumPack-summaryMethodOfPaymentDeferredFixedFee')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardPremiumPack-summaryMethodOfPaymentDeferredVariableFee')}`
        };

        const paymentMethodType = immHirePaymentMethod.get('type');
        const paymentMethodText = paymentMethod[paymentMethodType];
        const paymentMethodSymbol = paymentMethodType === CARD_PAYMENT_METHOD_FIXED ? EURO_SYMBOL : PERCENTAGE_SYMBOL;
        const paymentMethodValue = paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE
            ? paymentMethodText
            : `${paymentMethodText} ${immHirePaymentMethod.get('value')} ${paymentMethodSymbol}`;

        const accountIban = getLastNChars(immAccount.get('iban'));

        return (
            <div className="row hire-card-premium-pack-success__summary">
                <div className="col-xs-6 hire-card-premium-pack-success__summary-left-column">
                    <FormattedText
                        className="col-xs-12 hire-card-premium-pack-success__summary-title"
                        value="hireCardPremiumPack-summarySelectedName"
                    />
                    <div className="col-xs-12 hire-card-premium-pack-success__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                    <FormattedText
                        className="col-xs-12 hire-card-premium-pack-success__summary-title"
                        value="hireCardPremiumPack-summarySelectedLimit"
                    />
                    <OneLineSymbolAmount
                        amountObject={limitObj}
                        amountObjectFormatted={getSplittedNumber(limitObj).whole}
                        className="col-xs-12 hire-card-premium-pack-success__summary-value"
                        language={getLanguage()}
                        trimDecimals={true}
                    />
                </div>
                <div className="col-xs-5 col-xs-offset-1">
                    <FormattedText
                        className="col-xs-12 hire-card-premium-pack-success__summary-title"
                        value="cardDetails-associatedAccount"
                    />
                    <div className="col-xs-12 hire-card-premium-pack-success__summary-value">
                        {`${immAccount.get('alias')} ${accountIban}`}
                    </div>
                    <FormattedText
                        className="col-xs-12 hire-card-premium-pack-success__summary-title"
                        value="hireCardPremiumPack-summaryPaymentMethod"
                    />
                    <div className="col-xs-12 hire-card-premium-pack-success__summary-value">
                        {paymentMethodValue}
                    </div>
                </div>
            </div>
        );
    }

    buildTexts() {
        const { immCollectivesCardContent, immHireCardPremiumPack, immShippingAddress } = this.props;
        let textElement;
        let titleKey;

        const pendingAnalysis = immHireCardPremiumPack.get('hiringStatus') === PENDING;
        const isCollectiveUserPreferenceAllowed = !!immCollectivesCardContent.get(PREMIUM_PACK_HIRING);

        if (pendingAnalysis) {
            titleKey = isCollectiveUserPreferenceAllowed ? "hireCardPremiumPack-collectiveSuccessTitlePending" :
                "hireCardPremiumPack-successTitlePending";
            textElement = (
                <div className="col-xs-8 hire-card-premium-pack-success__text">
                    <div className="hire-card-premium-pack-success__text-pending">
                        <FormattedText value="hireCardPremiumPack-successText1Pending" />
                    </div>
                    <FormattedText value="hireCardPremiumPack-successText2Pending" />
                </div>
            );
        } else {
            const address = PersonalDataHelper.getHireFormattedAddress(immShippingAddress);

            titleKey = isCollectiveUserPreferenceAllowed ? "hireCardPremiumPack-collectiveSuccessTitleCompleted" :
                "hireCardPremiumPack-successTitleCompleted";
            textElement = (
                <div className="col-xs-8 hire-card-premium-pack-success__text">
                    <FormattedText value="hireCardPremiumPack-successText1Completed" />
                    <div className="hire-card-premium-pack-success__address">
                        <i className="hire-card-premium-pack-success__address-icon icon icon-s-locacion" />
                        {address}
                    </div>
                </div>
            );
        }

        return {
            textElement,
            titleKey
        };
    }

    buildMessage() {
        const { immProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);
        const url1 = formatText('hireCardPremiumPack-successWarningUrl1');
        const url2 = formatText('hireCardPremiumPack-successWarningUrl2');
        const url3 = formatText('hireCardPremiumPack-successWarningUrl3');
        const text = !!email ? 'hireCardPremiumPack-successWarningTextSentByEmail' : 'hireCardPremiumPack-successWarningTextUpdateEmail';
        const injectedString = [
            ...(!!email ? [email] : [])
        ];

        return (
            <div>
                <div className="col-xs-12">
                    <OKMessage type="informative">
                        <FormattedText value="hireCardPremiumPack-successWarningText1" />
                        &nbsp;
                        <OKLink modifier="inline" target="_blank" to={url1}>
                            <FormattedText value="hireCardPremiumPack-successWarningText2" />
                        </OKLink>
                        ,&nbsp;
                        <OKLink modifier="inline" target="_blank" to={url2}>
                            <FormattedText value="hireCardPremiumPack-successWarningText3" />
                        </OKLink>
                        &nbsp;
                        <FormattedText value="hireCardPremiumPack-successWarningText4" />
                        &nbsp;
                        <OKLink modifier="inline" target="_blank" to={url3}>
                            <FormattedText value="hireCardPremiumPack-successWarningText5" />
                        </OKLink>
                        &nbsp;
                        <FormattedText value="hireCardPremiumPack-successWarningText6" />

                        <div className="hire-card-premium-pack-success__message-paragraph">
                            <FormattedText value={text} injectedStrings={injectedString} />
                        </div>
                    </OKMessage>
                </div>
            </div>
        );
    }

    render() {
        const {
            extraImage,
            immCollectivesCardContent,
            immHireCardImageSelector,
            immHireCardPremiumPack,
            immProfile,
            processDetail
        } = this.props;
        let content;
        let subtitle;

        if (immProfile.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const { textElement, titleKey } = this.buildTexts();
            const messageSection = this.buildMessage();
            const summarySection = this.buildSummary();
            const selectedImageId = immHireCardImageSelector.get('selectedImageId');
            const immImageData = immHireCardImageSelector.getIn(['imagesById', selectedImageId]);
            const extraImageSrc = immHireCardImageSelector.getIn(['extraImageById', extraImage, 'url']);
            const wizardSuccessIcon = immHireCardPremiumPack.get('hiringStatus') === PENDING ? 'pending' : '';

            const pendingAnalysis = immHireCardPremiumPack.get('hiringStatus') === PENDING;
            const isCollectiveUserPreferenceAllowed = !!immCollectivesCardContent.get(PREMIUM_PACK_HIRING);

            if(isCollectiveUserPreferenceAllowed){
                const subtitleKey = pendingAnalysis ? "successSubtitleCollective" : "successCompletedPremiumSubtitleCollective"
                subtitle = <FormattedText value={`hireCardPremiumPack-${subtitleKey}`} />;
            }
            const goBackButton = {
                label: (
                    <FormattedText
                        format="uppercase"
                        value="hireCardPremiumPack-successBackButtonText"
                    />
                ),
                url: '/myprofile/cards'
            };

            content = (
                <WizardSuccess
                    iconModifier={wizardSuccessIcon}
                    mainButton={goBackButton}
                    processDetail={processDetail}
                    successMessage={formatText(titleKey)}
                    successSubMessage={subtitle}
                    tealium={catalogue[analyticsId.PREMIUM_PACK_CARD_WIZARD_SUCCESS]({ productName: processDetail })}
                    isSecondVersion
                >
                    <article className="hire-card-premium-pack-success">
                        <div className="row">
                            <div className="col-xs-4 hire-card-premium-pack-success__image-container">
                                <div className="hire-card-premium-pack-success__extra-image-container">
                                    <img
                                        src={extraImageSrc}
                                        className="hire-card-premium-pack-success__extra-image"
                                    />
                                </div>
                                <HireSuccessStepCardImage
                                    className="hire-card-premium-pack-success__card-image"
                                    immImageData={immImageData}
                                />
                            </div>
                            {textElement}
                        </div>
                        {summarySection}
                        <div className="row hire-card-premium-pack-success__message">
                            {messageSection}
                        </div>
                    </article>
                </WizardSuccess>
            );
        }
        return content
    }
}

HireCardPremiumPackSuccess.propTypes = {
    extraImage: PropTypes.string.isRequired,
    immAccount: PropTypes.object.isRequired,
    immCollectivesCardContent: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardPremiumPack: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    processDetail: PropTypes.string
};

module.exports = HireCardPremiumPackSuccess;
